var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSearchFill = function SvgSearchFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.19 18.54l-.73.73-3.72-3.72.72-.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.19 18.54l-.73.73-3.72-3.72.72-.72z",
    fill: "#fff",
    opacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.09,
    cy: 9.98,
    r: 4.76,
    transform: "rotate(-45 10.093 9.98)",
    fill: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87 13.2a4.55 4.55 0 116.44 0 4.56 4.56 0 01-6.44 0zM15 15.73l-.06-.29.44-.44.28.06.6.6-.67.67zm3.48 3.46l-2.38-2.35.67-.67 2.36 2.36zm1.31-1L16 14.41l-.87-.18-.24.24-.42-.47a5.93 5.93 0 10-.51.49l.44.44-.24.24.18.87 3.73 3.73.61.18 1.2-1.2z"
  })));
};
export default SvgSearchFill;